import { Directive } from '@angular/core';

@Directive({
  selector: '[atlasPopup]'
})
export class AtlasPopupDirective {

  constructor() { }

}
